import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';

function Instruction() {
  return (
    <ToastContainer className="position-static">
      <Toast>
        <Toast.Header>
          <img src="holder.js/20x20?text=%20" className="rounded me-2" alt="" />
          <strong className="me-auto blue">Only for admins!</strong>
          <small className="text-muted"></small>
        </Toast.Header>
        <Toast.Body>Get registered as Admin and Generate the link for the bucket saving and share to your members !</Toast.Body>
      </Toast>
     
    </ToastContainer>
  );
}

export default Instruction;